function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.566 61.484a31.328 31.328 0 003.418-.823M31.845 62c1.156 0 2.297-.063 3.42-.183",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.136 54.669C15.642 52.178 7.854 42.973 7.854 31.999c0-6.442 2.69-12.27 7.033-16.492l1.636 1.59c.303.295.714.46 1.143.46.89 0 1.612-.704 1.612-1.57v-7.32c0-1.228-1.022-2.223-2.284-2.223H9.47c-.892 0-1.617.705-1.615 1.573 0 .416.17.816.472 1.11l1.708 1.662C4.455 16.218 1 23.715 1 31.999c0 15.82 12.59 28.78 28.558 29.92",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.845 55.333a24.93 24.93 0 01-3.43-.236M26.124 2.516a31.314 31.314 0 00-3.418.823M31.845 2c-1.156 0-2.298.062-3.42.182",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.553 9.33C48.047 11.823 55.835 21.027 55.835 32c0 6.443-2.69 12.27-7.033 16.493l-1.633-1.588a1.64 1.64 0 00-1.142-.46c-.892-.001-1.616.703-1.616 1.571v7.317c0 1.228 1.022 2.222 2.284 2.222h7.526c.892 0 1.615-.702 1.615-1.569 0-.416-.17-.816-.473-1.112l-1.71-1.663c5.581-5.43 9.036-12.927 9.036-21.211 0-15.82-12.59-28.78-28.558-29.92",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.845 8.667c1.164 0 2.31.081 3.43.237M20.237 36.426v7.608c0 .288.21.535.5.589l10.888 2.041c.09.02.183.025.275.025.125 0 .244-.02.363-.044l14.753-3.63a.563.563 0 00.436-.544v-7.99M36.342 23.962L26.16 24.98a.812.812 0 00-.581.334l-7.275 10.41",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.692 25.186L33.054 36.2a1.744 1.744 0 001.79.733l12.936-2.516a.951.951 0 00.782-.927.927.927 0 00-.185-.553L41.52 23.71a.591.591 0 00-.545-.245l-1.3.166M31.9 38.047v8.643M23.014 45.05v-7.066c0-.562.468-1.018 1.046-1.018.043 0 .086.003.13.008l3.169.386c.69.083 1.209.655 1.209 1.332v7.4",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.344 27.243v-4.851c0-.304.253-.55.566-.55h2.2c.313 0 .566.246.566.55v6.472",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgDevADom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "/img/dev-a-dom.svg";
export { SvgDevADom as ReactComponent };